import { z } from 'zod';

export const required = () =>
    z.any().refine(
        val => {
            if (typeof val === 'string') {
                return val.trim().length > 0;
            }

            return val !== undefined && val !== null;
        },
        {
            message: 'Required field'
        }
    );
